export const resources = {
    en: {
        translation: {
            label: {
                "welcome-label": "Welcome",
                "claims-label": "Claims",
                "reviewed-label": "Reviewed",
                "review-claims-now": "Review Claims Now",
                "shop-for-healthcare": "Shop for Healthcare",
                "get-started": "Get Started",
                "achievements": "Achievements",
                "medexpert-services": "MedExpert Services",
                "benefit-information": "Healthcare Spending",
                "your-fame-reports": "Your FAME Reports",
                "go": "Go",
                "facility-type": "Facility Type",
                "estimate-you-pay": "Estimate you pay",
                "prior-auth-required": 'Prior Authorization Required',
                "estimate-employer-pays": "Estimate {{employer}} pays",
                "estimate-the-fund-pays": "Estimate {{theFund}} pays",
                "estimate-reference": "Estimate reference",
                "estimate-number-of-charges": "Estimate number of charges",
                "expected": "Expected",
                "probable": "Probable",
                "possible": "Possible",
                "estimate-date-of-service": "Estimate date of service",
                "services-to-be-rendered-by": "Services to be rendered by",
                "expected-charges": "Expected Charges",
                "probable-charges": "Probable Charges",
                "possible-charges": "Possible Charges",
                "collapse-all": "Collapse All",
                "expand-all": "Expand All",
                "i-have-a-question": "I HAVE A QUESTION",
                "compare-providers": "COMPARE PROVIDERS",
                "refine-my-estimate": "REFINE-MY-ESTIMATE",
                "approved": "Approved",
                "alert": "Alert",
                "cancel": "Cancel",
                "confirm": "Confirm",
                "call-us-at": "Call us at",
                "refine-my-estimate-popup": "Refine My Estimate",
                "enter-search-term": "Enter Search Term",
                "home-address": "Home Address",
                "distance": "Distance",
                "distance-lowercase": "distance",
                "stars": "stars",
                "cost": "cost",
                "sorted-by": "Sorted By",
                "preview-service-at-this-provider": "PREVIEW SERVICE AT THIS PROVIDER",
                "approx": "Approx",
                "logout": "logout",
                "full-name": "Name",
                "first-name": "First Name",
                "middle-name": "Middle Name",
                "last-name": "Last Name",
                "date-of-birth": "Date of Birth",
                "last-4-ssn": "Last 4 SSN",
                "org-name": "Org Name",
                "ext-pid": "Ext. Person ID",
                "mi-pid": "MI PID",
                "npi": "NPI",
                "gender": "Gender",
                "taxonomy": "Taxonomy",
                "phone": "Phone",
                "email": "Email",
                "address1": "Address 1",
                "address2": "Address 2",
                "city": "City",
                "state": "State",
                "zipcode": "Zipcode",
            },
            paragraph: {
                "benefit-intro": "presents to you an exceptional way to explore, understand, and evaluate your healthcare",
                "shop-intro": "Recognize the world of medical excellence around you",
                "we-are-here": "We're here for you",
                "achievements-intro": "We offer rewards to motivate you to explore your healthcare choices. Awards are designed to walk you through healthcare processes and learning opportunities.",
                "medexpert-services-intro": "We provide context into a complicated healthcare system. Rely on our staff to find answers to dial in your medical care.",
                "benefit-information-intro": "Showing the status of your deductibles, medications and needed vaccinations all in one place so you don't need to scramble for documents.",
                "your-fame-reports-intro": "MedExpert technology scours medical research to discover the best course of action and rates healthcare professionals with the GRADE system.",
                "delete-estimate": "Are you sure you would like to delete this Estimate?",
                "available-time": "We are available 7AM to 7PM in the continental US",
                "refine-my-estimate-msg-1": "We will communicate with your provider, {{provider}}, to refine your estimate if possible.",
                "refine-my-estimate-msg-2": "How can we notify you when the process concludes?",
                "refine-my-estimate-msg-3": "Use a phone number we have on file",
                "refine-my-estimate-msg-4": "Use the phone number provided here",
                "only-show-inn-providers": "Only show in-network providers",
                "incentive-title-label": "Which result is used to calculate your incentives?",
            },
            claim: {
                "pharma_category": "Pharmacy",
                "medical_category": "Medical",
                "trans_category": "Transportation",
                "mic_category": "Not shown to patient"
            },
            eomb: {
                "overall_label": "Overall",
                "num_of_eligible_mem_label": "Number of Currently Eligible Members",
                "num_of_eligible_mem_segment": "Individuals with an eligibility span in ",
                "numOfMemSinceProgStartLabel": "Number of Eligible Members Since Year Start",
                "numOfMemSinceProgStartSegment": "All members since ",
                "claimTrendLabel": "Claim Trend",
                "totalAmountLabel": "Total Amount Paid",
                "totalAccountLabel": "Claim Count",
                "mostRecentClaimsFileLabel": "Most Recent Claims File",
                "seeMoreButton": "Click here to see more",
                "mostRecentFileLabel": "Most Recent File",
                "last60DaysLabel": "Previous File",
                "mostMovementLabel": "File One Year Ago",
                "lastFileLoadedLabel": "Last File Loaded",
                "totalPaidAmountLabel": "Total Paid Amount",
                "totalNumberClaimsLabel": "Total Number of Claims",
                "oldestServiceStartDateLabel": "Oldest Service Start Date",
                "mostRecentServiceStartDate": "Most Recent Service Start Date",
                "movementClaimTypeLabel": "Movement By Claim Type",
                "paidAmountByServicePlaceLabel": "Paid Amount By Place Of Service",
                "viewFullReportLabel": "View Full Report",
                "claimLagLabel": "Claim Lag",
                "paidAmountByServiceStateLabel": "Paid Amount by State of Service",
                "yearPaidToDate": "Paid Amount Based on Service Date",
            },
            history: {
                "claimsGroupByVisit": "Claims Group by Visit",
                "allClaims": "All Claims"
            },
            recon: {
                "earned_label": "Earned on ",
                "point_label": "POINT",
                "dont_show_popup_text": "Do not show again this session.",
                "claim_group_popup_text_mobile": "Helpful tips:<br/><br/>" +
                    "1. A single visit to a provider may generate multiple claims. We have grouped them for your convenience based on the date, location, and type of service.<br/><br/>" +
                    "2. Some claims may not be viewable on your portal at this time. Please check back regularly as claims will be posted once they have been adjudicated and paid; this may take some time.<br/><br/>" +
                    "3. There are two ways to review your claims: - View recent visits as shown here, or - View complete listing of all claims by clicking \"HISTORY\" on the top of the screen.<br/><br/>",
                "claim_group_popup_help_text_mobile": "We are here to help, call us at <a href='tel:8009991999' style='color:rgb(139, 213, 245);'>(800) 999-1999</a>.",
                "claim_group_popup_text": "This tab will show you estimates you have started, estimates you have approved, and the claims" +
                    "paid on your behalf. If we were able to match an estimate to a service, we will tie them together for you.<br/><br/>" +
                    "Helpful tips when reviewing rendered services:<br/><br/>" +
                    "1. A single visit to a provider may generate multiple claims. We have grouped them for your convenience based on the date, location, and type of service.<br/><br/>" +
                    "2. Some claims may not be viewable on your portal at this time. Please check back regularly as claims will be posted once they have been adjudicated and paid; this may take some time.<br/><br/>" +
                    "3. There are two ways to review your claims: - View recent visits as shown here, or - View complete listing of all claims by clicking \"HISTORY\" on the top of the screen.<br/><br/>",
                "claim_group_popup_help_text": "We are here to help, call us at <span style='color:rgb(139, 213, 245);'>(800) 999-1999</span>."
            },
            vaccination: {
                "vaccination-instruction": "You may upload a photo of your COVID-19 Vaccination card and details here. (Acceptable file types are: jpg, jpeg, png and pdf.)",
                "wrong-type-warning": "Please choose one of the valid file types: <div>  .jpg, .jpeg, .png, or .pdf</div>",
                "first-dose": "First Dose",
                "second-dose": "Second Dose",
                "product-name-manufacturer": "Product Name/Manufacturer",
                "lot-number": "Lot Number",
                "date-administered": "Date Administered",
                "clinic-location-administered": "Clinic/Location Administered",
                "photo": "Photo",
                "status": "Status",
                "pending-info": "Thank you, we have received your documentation. Your submission is being reviewed. " +
                    "If found to meet the requirements for this Wellness Step, " +
                    "the above 'Pending' status will change to 'Success' within two business days.",
                "success-info": "Thank you for submitting your documentation in fulfillment of the Medical Wellness Step.",
                "note-info": "Remaining Wellness Steps will be available for completion beginning <span style='font-weight: bold'>September 20</span>.",
                "note-success": "You're not done! ",
                "no-file-error": 'Please choose a file that shows your proof of vaccination',
            },
            vaccination_test: {
                "test-type": "Test Type",
                "test-date": "Test Date",
                "test-location": "Test Location",
                "test-result": "Result",
            },
            faqs: {
                "introduction": "The following section contains a number of frequently asked questions (FAQs), and the answers, regarding the QMMS program.",
            },
            contact_us: {
                "phone": "Please call MedExpert at",
                "email": "email us at",
                "orLabel": "or",
            },
            "admin-label": "Admin",
            "my-account-label": "My Account",
            "faqs-label": "FAQs",
            "contact-us-label": "CONTACT US",
            "privacy-policy-label": "Privacy Policy",
            "terms-conditions-label": "Terms & Conditions",
            "no-file-selected": "No File Chosen",
            "choose-file": "CHOOSE FILE",
            "submit": "Submit",
            message: {
                'thank_you_title': "Thank you!",
                'success_title': "Success",
                'error_title': "Error",
                'pending_title': "Pending",
                'note_title': 'NOTE',
                'awesome_label': "Awesome!",
                'upload_file_success_message': "Please allow up to two business days for these results to be processed and visible in the My Results section. " +
                    "If you have not entered all required results, your Lab Work status will revert to ‘Incomplete’ at that time, and you will then be allowed to upload additional results."
            },
            error: {
                "required": "{{field}} is required",
                "invalid_date": "Invalid Date",
                "invalid_zipcode": "Please enter a valid zipcode",
            }
        }
    },
    es: {
        translation: {
            label: {
                "welcome-label": "Bienvenido/a",
                "claims-label": "reclamaciones",
                "reviewed-label": "revisadas",
                "review-claims-now": "Revisar reclamaciones ahora",
                "shop-for-healthcare": "Buscar servicios médicos",
                "get-started": "Get Started",
                "achievements": "Logros",
                "medexpert-services": "Los Servicios de MedExpert",
                "benefit-information": "Información de Beneficios",
                "your-fame-reports": "Sus Informes 'FAME'",
                "go": "Ir",
                "facility-type": "Facility Type",
                "estimate-you-pay": "Monto estimado a pagar por usted",
                "prior-auth-required": 'Se requiere Autorización Previa',
                "estimate-employer-pays": "Monto estimado a pagar por {{employer}}",
                "estimate-the-fund-pays": "Monto estimado a pagar por {{theFund}}",
                "estimate-reference": "Numero de referencia del monto estimado",
                "estimate-number-of-charges": "Cantidad de cargos del monto estimado",
                "expected": "Previstos",
                "probable": "Probables",
                "possible": "Posibles",
                "estimate-date-of-service": "Fecha estimada de servicio",
                "services-to-be-rendered-by": "Servicios a proporcionarse por",
                "expected-charges": "Cargos previstos",
                "probable-charges": "Cargos probables",
                "possible-charges": "Cargos posibles",
                "collapse-all": "Reducir todos",
                "expand-all": "Desplegar todos",
                "i-have-a-question": "TENGO UNA PREGUNTA",
                "compare-providers": "COMPARAR PROVEEDORES",
                "refine-my-estimate": "MEJORAR MI ESTIMACIÓN",
                "approved": "Aprobada",
                "alert": "Alerta",
                "cancel": "Cancelar",
                "confirm": "Confirmar",
                "call-us-at": "Llámenos al",
                "refine-my-estimate-popup": "Mejorar Mi Estimacion",
                "enter-search-term": "Introducir término a buscar",
                "home-address": "Domicilio",
                "distance": "Distancia",
                "distance-lowercase": "distancia",
                "stars": "calificación",
                "cost": "costo",
                "sorted-by": "Ordenado por",
                "preview-service-at-this-provider": "PREVISUALIZAR SERVICIO EN ESTE PROVEEDOR",
                "approx": "Aprox",
                "logout": "Salir",
                "full-name": "Nombre",
                "first-name": "Nombre",
                "middle-name": "Middle Name",
                "last-name": "Apellidoe",
                "date-of-birth": "Date of Birth",
                "last-4-ssn": "Los últimos 4 dígitos de su SSN",
                "org-name": "Org Name",
                "ext-pid": "Ext. Person ID",
                "mi-pid": "MI PID",
                "npi": "NPI",
                "gender": "Sexo",
                "taxonomy": "Taxonomy",
                "phone": "Phone",
                "email": "Email",
                "address1": "Address 1",
                "address2": "Address 2",
                "city": "City",
                "state": "State",
                "zipcode": "Zipcode",
            },
            paragraph: {
                "benefit-intro": "le presenta una forma excepcional de explorar, entender y evaluar su atención médica",
                "shop-intro": "Conozca el mundo de la excelencia médica que lo rodea",
                "we-are-here": "Estamos aquí para usted",
                "achievements-intro": "Ofrecemos recompensas para motivarlo a explorar sus opciones de atención médica. Los premios están diseñados para guiarlo a través de los procesos de atención médica y las oportunidades de aprendizaje.",
                "medexpert-services-intro": "Brindamos contexto a un sistema de salud complicado. Confíe en nuestro personal para encontrar respuestas para centrar su atención médica.",
                "benefit-information-intro": "Muestra el estado de sus deducibles, medicamentos y vacunas necesarias, todo en un solo lugar para que no se desespere buscando sus documentos.",
                "your-fame-reports-intro": "La tecnología MedExpert examina la investigación médica para descubrir el mejor plan de acción y califica a los profesionales de la salud con el sistema GRADE.",
                "delete-estimate": "¿Está seguro de que quiere eliminar esta estimación?",
                "available-time": "Estamos disponibles de 7AM a 7PM en EEUU continental",
                "refine-my-estimate-msg-1": "Nos comunicaremos con su proveedor, {{provider}}, para hacer más precisa la estimación si es posible.",
                "refine-my-estimate-msg-2": "¿Cómo podemos avisarle cuando se termine el proceso?",
                "refine-my-estimate-msg-3": "Usar un número de teléfono registrado",
                "refine-my-estimate-msg-4": "Usar el número de teléfono que se introduce aquí",
                "only-show-inn-providers": "Mostrar solo proveedores en su red",
                "incentive-title-label": "¿Cuál resultado se usa para calcular su incentivo?",
            },
            claim: {
                "pharma_category": "Pharmacy",
                "medical_category": "Medical",
                "trans_category": "Transportation",
                "mic_category": "Not shown to patient"
            },
            eomb: {
                "overall_label": "Overall",
                "num_of_eligible_mem_label": "Number of Currently Eligible Members",
                "num_of_eligible_mem_segment": "Individuals with an eligibility span in ",
                "numOfMemSinceProgStartLabel": "Number of Eligible Members Since Year Start",
                "numOfMemSinceProgStartSegment": "All members since ",
                "claimTrendLabel": "Claim Trend",
                "totalAmountLabel": "Total Amount Paid",
                "totalAccountLabel": "Claim Count",
                "mostRecentClaimsFileLabel": "Most Recent Claims File",
                "seeMoreButton": "Click here to see more",
                "mostRecentFileLabel": "Most Recent File",
                "last60DaysLabel": "Previous File",
                "mostMovementLabel": "File One Year Ago",
                "lastFileLoadedLabel": "Last File Loaded",
                "totalPaidAmountLabel": "Total Paid Amount",
                "totalNumberClaimsLabel": "Total Number of Claims",
                "oldestServiceStartDateLabel": "Oldest Service Start Date",
                "mostRecentServiceStartDate": "Most Recent Service Start Date",
                "movementClaimTypeLabel": "Movement By Claim Type",
                "paidAmountByServicePlaceLabel": "Paid Amount By Place Of Service",
                "viewFullReportLabel": "View Full Report",
                "claimLagLabel": "Claim Lag",
                "paidAmountByServiceStateLabel": "Paid Amount by State of Service",
                "yearPaidToDate": "Paid Amount Based on Service Date",
            },
            history: {
                "claimsGroupByVisit": "Reclamaciones agrupadas por visita",
                "allClaims": "Todas las reclamaciones"
            },
            recon: {
                "earned_label": "Ganado el ",
                "point_label": "PUNTO",
                "dont_show_popup_text": "No volver a mostrar durante esta sesión.",
                "claim_group_popup_text_mobile": "Consejos prácticos:<br/><br/>" +
                    "1. Una sola visita a un proveedor puede generar múltiples reclamaciones. Las hemos agrupado para su conveniencia según la fecha, la ubicación y el tipo de servicio.<br/><br/>" +
                    "2. Es posible que algunas reclamaciones no se puedan ver en su portal en este momento. Vuelva a consultar periódicamente, ya que las reclamaciones se publicarán una vez que hayan sido adjudicadas y pagadas; Esto puede tomar algo de tiempo.<br/><br/>" +
                    "3. Hay dos formas de revisar sus reclamaciones: - Ver visitas recientes como se muestra aquí, o - Ver la lista completa de todas las reclamaciones haciendo clic en \"HISTORIAL\" en la parte superior de la pantalla.<br/><br/>",
                "claim_group_popup_help_text_mobile": "Estamos para ayudar - llámenos al <a href='tel:8009991999' style='color:rgb(139, 213, 245);'>(800) 999-1999</a>.",
                "claim_group_popup_text": "Consejos prácticos:<br/><br/>" +
                    "1. Una sola visita a un proveedor puede generar múltiples reclamaciones. Las hemos agrupado para su conveniencia según la fecha, la ubicación y el tipo de servicio.<br/><br/>" +
                    "2. Es posible que algunas reclamaciones no se puedan ver en su portal en este momento. Vuelva a consultar periódicamente, ya que las reclamaciones se publicarán una vez que hayan sido adjudicadas y pagadas; Esto puede tomar algo de tiempo.<br/><br/>" +
                    "3. Hay dos formas de revisar sus reclamaciones: - Ver visitas recientes como se muestra aquí, o - Ver la lista completa de todas las reclamaciones haciendo clic en \"HISTORIAL\" en la parte superior de la pantalla.<br/><br/>",
                "claim_group_popup_help_text": "Estamos para ayudar - llámenos al <span style='color:rgb(139, 213, 245);'>(800) 999-1999</span>."
            },
            vaccination: {
                "vaccination-instruction": "Puedes subir una foto de tu comprobante de vacunación COVID-19 y los detalles aquí. (Se aceptan los siguientes tipos de archivo: jpg, jpeg, png y pdf.)",
                "wrong-type-warning": "Por favor, selecciona uno de los tipos de archivo válidos: <div> .jpg, .jpeg, .png, o .pdf </div>",
                "first-dose": "Primera dosis",
                "second-dose": "Segunda dosis",
                "product-name-manufacturer": "Fabricante/Marca de la vacuna",
                "lot-number": "Número de lote",
                "date-administered": "Fecha de aplicación",
                "clinic-location-administered": "Clínica / centro de vacunación",
                "pending-info": "Gracias, tu documentación está en revisión. " +
                    "Si se determina que cumple con los requisitos para este Paso de Bienestar, " +
                    "el estado 'Pendiente' cambiará a 'Éxito' dentro de dos días hábiles.",
                "success-info": "Gracias por enviar tu documentación en cumplimiento del Paso de Bienestar Médico.",
                "note-info": "Los demás Pasos de Bienestar estarán disponibles para ser completados a partir del <span style='font-weight: bold'>20 de septiembre</span>.",
                "note-success": "¡No has terminado! ",
                "no-file-error": 'Selecciona un archivo que muestre tu comprobante de vacunación',
            },
            vaccination_test: {
                "test-type": "Test Type",
                "test-date": "Test Date",
                "test-location": "Test Location",
                "test-result": "Result",
            },
            faqs: {
                "introduction": "La siguiente sección contiene información sobre las preguntas más frecuentes, y las respuestas sobre el programa QMMS.",
            },
            contact_us: {
                "phone": "Por favor llame a MedExpert al",
                "email": "mándenos un correo electrónico a",
                "orLabel": "o",
            },
            "admin-label": "Admin",
            "my-account-label": "Mi Cuenta",
            "faqs-label": "FAQs",
            "contact-us-label": 'Contáctenos',
            "privacy-policy-label": "Política de privacidad",
            "terms-conditions-label": "Términos y Condiciones",
            "no-file-selected": "Ningún archivo seleccionado",
            "choose-file": "Buscar archivo",
            "submit": "Enviar",
            message: {
                'thank_you_title': "¡Gracias!",
                'success_title': "Éxito",
                'error_title': "Error",
                'pending_title': "Pendiente",
                'note_title': 'NOTA',
                'awesome_label': "¡Excelente!",
                'upload_file_success_message': "Por favor espera hasta dos días hábiles para que este envío sea revisado, procesado y visible en esta página. " +
                    "Si durante la revisión detectamos que no has enviado toda la información requerida, el paso del comprobante de vacunación se considerará incompleto y se revertirá para permitir cargas adicionales en ese momento."
            },
            error: {
                "required": "Se requiere {{field}}",
                "invalid_date": "Invalid Date",
                "invalid_zipcode": "Please enter a valid zipcode",
            }
        }
    }
}
